/**
 * Định dạng không phụ thuộc ngôn ngữ. Ngày giờ và chuỗi "x phút trước" nằm ở
 * `i18n.tsx` (fmtDate / fmtAgo) vì chúng phải đổi theo locale đang chọn.
 */
export function formatMs(ms: number | null | undefined): string {
  if (ms == null) return "—";
  return ms < 1000 ? `${ms} ms` : `${(ms / 1000).toFixed(2)} s`;
}

/**
 * Nhiều domain được lưu không kèm scheme (`123j88.com`). Đưa thẳng vào href thì
 * trình duyệt hiểu là đường dẫn tương đối và nhảy trong SPA — phải tự thêm https.
 */
export function externalUrl(domain: string): string {
  return /^[a-z][a-z0-9+.-]*:\/\//i.test(domain) ? domain : `https://${domain}`;
}

/**
 * Trả về BẢN SAO đã sắp xếp theo trường thời gian giảm dần (mới nhất trước) —
 * dùng để mọi bảng mặc định hiển thị bản ghi mới nhất trên đầu. Không đổi mảng gốc;
 * người dùng vẫn bấm cột để đổi sắp xếp như bình thường.
 */
export function newestFirst<T>(rows: T[], field: keyof T): T[] {
  const ts = (v: unknown) => (v ? new Date(v as string).getTime() || 0 : 0);
  return [...rows].sort((a, b) => ts(b[field]) - ts(a[field]));
}
